module.exports = __webpack_public_path__ + "static/media/bootstrap-min.193f7853.jpg";